import { jsx as m } from "react/jsx-runtime";
import n from "react";
import { SvgIconBase as c } from "./svg-icon-base.js";
function i(o, t) {
  const r = (e) => /* @__PURE__ */ m(c, { name: o, version: t, ...e });
  return r.displayName = `Icon${o}`, n.memo(r);
}
export {
  i as createSvgIcon
};
